import http from '../../network/http'
import { AddPointDTO } from './models'

class RiskApi {
  addPoint(dto: AddPointDTO) {
    return http.post<string>('/trade-risk/console/addpoint', dto)
  }
}

export default new RiskApi()
